import { SearchGif } from '../../components/gif/search-gif'

function Home() {
  return <SearchGif />;
}

export default Home;